import _slicedToArray from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { useEffect, useState } from 'react';
import { Input, useSelectCustomControl } from '@vtblife/uikit';
export var InputControl = function InputControl(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    onReset = _ref.onReset,
    hasSuggestions = _ref.hasSuggestions;
  var _useSelectCustomContr = useSelectCustomControl(),
    toggle = _useSelectCustomContr.toggle,
    opened = _useSelectCustomContr.opened,
    control = _useSelectCustomContr.control;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isVisible = _useState2[0],
    setIsVisible = _useState2[1];
  var handleFocus = function handleFocus() {
    setIsVisible(true);
  };
  var handleBlur = function handleBlur() {
    setIsVisible(false);
  };
  useEffect(function () {
    if (!isVisible && opened) {
      toggle();
    } else if (hasSuggestions && isVisible && !opened) {
      toggle();
    } else if (!hasSuggestions && opened) {
      toggle();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasSuggestions, opened, isVisible]);
  return React.createElement("div", {
    ref: control
  }, React.createElement(Input, {
    size: "m",
    value: value,
    placeholder: "\u0413\u043E\u0440\u043E\u0434",
    dataTest: "select-region-quiz-input",
    onChange: onChange,
    onReset: onReset,
    onBlur: handleBlur,
    onFocus: handleFocus
  }));
};